import { render, staticRenderFns } from "./LayoutSelector.vue?vue&type=template&id=26499db6&scoped=true&"
import script from "./LayoutSelector.vue?vue&type=script&lang=js&"
export * from "./LayoutSelector.vue?vue&type=script&lang=js&"
import style0 from "./LayoutSelector.vue?vue&type=style&index=0&id=26499db6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26499db6",
  null
  
)

export default component.exports